import { useRef, useState } from 'react';
import { useProfile } from '../../profile/ProfileContext';
import './AvatarEditor.css';

// Your profile picture: shown in rooms, on friends' lists and on the account button.
const AvatarEditor = ({ name }: { name: string }) => {
  const { myAvatarUrl, upload, remove } = useProfile();
  const input = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const run = async (action: () => Promise<void>, done: string) => { setBusy(true); setMessage(''); try { await action(); setMessage(done); } catch (error: any) { setMessage(error.message || 'That didn’t work. Please try again.'); } finally { setBusy(false); } };
  const initials = name.split(' ').map(part => part[0]).join('').slice(0, 2).toUpperCase() || '?';
  return <div className="avatar-editor">
    <button className="avatar-editor__photo" onClick={() => input.current?.click()} disabled={busy} aria-label={myAvatarUrl ? 'Change profile picture' : 'Add a profile picture'}>
      {myAvatarUrl ? <img src={myAvatarUrl} alt="" /> : <span>{initials}</span>}
      <b aria-hidden="true">{busy ? '…' : '📷'}</b>
    </button>
    <div className="avatar-editor__text">
      <strong>{myAvatarUrl ? 'Your profile picture' : 'Add a profile picture'}</strong>
      <small>Friends see it in your rooms and film nights.</small>
      <div className="avatar-editor__actions">
        <button onClick={() => input.current?.click()} disabled={busy}>{myAvatarUrl ? 'Change photo' : 'Choose a photo'}</button>
        {myAvatarUrl && <button className="avatar-editor__remove" onClick={() => run(remove, 'Photo removed.')} disabled={busy}>Remove</button>}
      </div>
      {message && <small className="avatar-editor__message" aria-live="polite">{message}</small>}
    </div>
    <input ref={input} type="file" accept="image/*" hidden onChange={event => { const file = event.target.files?.[0]; event.target.value = ''; if (file) run(() => upload(file), 'Looking good! Your photo is saved.'); }} />
  </div>;
};

export default AvatarEditor;
